{
    "builderForm": {
        "submit": "Dodaj aplikację"
    },
    "builderSettingTypes": {
        "themeName": "Motyw",
        "integrationsName": "Integracje",
        "domainsName": "Domeny",
        "userSourcesName": "Użytkownicy",
        "generalName": "Ogólne"
    },
    "createPageModal": {
        "header": "Utwórz stronę",
        "submit": "Dodaj stronę"
    },
    "pageForm": {
        "defaultName": "Strona",
        "nameLabel": "Nazwa",
        "errorNameNotUnique": "Strona o tej nazwie już istnieje",
        "nameTitle": "Nazwa",
        "nameSubtitle": "Unikalna nazwa strony",
        "pathTitle": "Ścieżka",
        "pathSubtitle": "Parametr można dodać za pomocą argumentu :parameter",
        "pathParamsTitle": "Parametry ścieżki",
        "pathParamsSubtitle": "Są zdefiniowane przez argument :parameter w ścieżce",
        "pathParamsSubtitleTutorial": "Parametry ścieżki służą do dynamicznego ładowania danych określonych parametrem. Aby użyć parametru, dodaj argument :parameter do ścieżki.",
        "namePlaceholder": "Wprowadź nazwę...",
        "addAnotherParameter": "Dodaj kolejny parametr zapytania",
        "addParameter": "Dodaj parametr zapytania",
        "queryParamsSubtitleTutorial": "Parametry zapytania służą do dynamicznego ładowania danych w zależności od podanego parametru.",
        "pathPlaceholder": "Wprowadź ścieżkę...",
        "queryParamsTitle": "Parametry zapytania"
    },
    "builderSettingsModal": {
        "title": "Aplikacja"
    },
    "sidebarComponentBuilder": {
        "createPage": "Nowa strona",
        "settings": "Ustawienia"
    },
    "publishActionModal": {
        "openInNewTab": "Otwórz w nowej karcie",
        "title": "Opublikuj",
        "description": "Uruchom aplikację, publikując ją na jednej z domen. Zwróć uwagę, że do aplikacji może być przypisana więcej niż jedna domena, a każda z domen może obsługiwać inną wersję aplikacji.",
        "publish": "Opublikuj",
        "publishSucceedTitle": "Witryna została opublikowana",
        "publishSucceedDescription": "Witryna została pomyślnie opublikowana.",
        "publishFailedTitle": "Opublikowanie witryny nie powiodło się",
        "publishFailedDescription": "Opublikowanie witryny nie powiodło się. Spróbuj ponownie później.",
        "noDomain": "Musisz mieć przynajmniej jedną domenę, aby opublikować swoją aplikację.",
        "importingState": "Importowanie",
        "publishSucceedLink": "Wyświetl witrynę",
        "addDomain": "Dodaj domenę"
    },
    "duplicatePageJobType": {
        "duplicating": "Duplikowanie",
        "duplicatedTitle": "Strona została zduplikowana",
        "name": "Zduplikuj stronę"
    },
    "headingElementForm": {
        "levelTitle": "Poziom",
        "textTitle": "Tekst",
        "textPlaceholder": "Wprowadź tekst...",
        "headingName": "Nagłówek {level} <h{level}>",
        "textError": "Ta wartość jest nieprawidłowa."
    },
    "addElementModal": {
        "searchPlaceholder": "Wyszukaj elementy",
        "title": "Dodaj nowy element",
        "elementInProgress": "Dodawanie elementu..."
    },
    "elementMenu": {
        "moveUp": "Przesuń w górę",
        "moveDown": "Przesuń w dół",
        "moveRight": "Przesuń w prawo",
        "moveLeft": "Przesuń w lewo",
        "selectParent": "Wybierz element nadrzędny",
        "drag": "Przeciągnij, aby zmienić kolejność"
    },
    "pageErrors": {
        "errorNameNotUnique": "Strona o tej nazwie już istnieje",
        "errorPathNotUnique": "Ścieżka o tej nazwie już istnieje",
        "errorStartingSlash": "Ścieżka musi się zaczynać od '/'",
        "errorValidPathCharacters": "Ta ścieżka zawiera nieprawidłowe znaki",
        "errorUniquePathParams": "Parametry ścieżki muszą być unikalne.",
        "errorNameNotUniqueDescription": "Podaj unikalną nazwę strony",
        "errorUniqueValidQueryParams": "Nazwy parametrów zapytania muszą być unikalne i poprawnie sformułowane."
    },
    "pageHeaderItemTypes": {
        "labelElements": "Elementy",
        "labelDataSource": "Dane",
        "labelVariables": "Zmienne",
        "labelSettings": "Ustawienia strony"
    },
    "pageActionTypes": {
        "preview": "Podgląd",
        "publish": "Opublikuj"
    },
    "lastPublishedDomainDate": {
        "neverPublished": "nigdy",
        "lastPublished": "Ostatnia publikacja:"
    },
    "elementsContext": {
        "searchPlaceholder": "Elementy wyszukiwania",
        "noElements": "Nie znaleziono żadnych elementów",
        "noPageElements": "Nie znaleziono elementów dla tej strony"
    },
    "elementType": {
        "heading": "Nagłówek",
        "headingDescription": "Tytuł nagłówka strony",
        "text": "Tekst",
        "textDescription": "Tekst wielowierszowy",
        "link": "Link",
        "linkDescription": "Link do strony/adres URL",
        "image": "Plik graficzny",
        "imageDescription": "Wyświetl plik graficzny",
        "inputText": "Wprowadzanie danych",
        "inputTextDescription": "Pole wprowadzania danych",
        "columnDescription": "Kontener zawierający kolumny",
        "column": "Kolumny",
        "button": "Przycisk",
        "buttonDescription": "Element zawierający przycisk",
        "table": "Tabela",
        "dropdown": "Lista rozwijana",
        "dropdownDescription": "Element rozwijany",
        "checkbox": "Pole wyboru",
        "checkboxDescription": "Element zawierający pole wyboru",
        "iframe": "IFrame",
        "authForm": "Formularz logowania",
        "authFormDescription": "Formularz logowania użytkownika",
        "formContainerDescription": "Element zawierający formularz",
        "tableDescription": "Element zawierający tabelę",
        "formContainer": "Formularz",
        "iframeDescription": "Ramka typu iFrame",
        "choice": "Opcja wyboru",
        "choiceDescription": "Wybór pojedynczej/wielu wartości",
        "repeat": "Powtórz",
        "repeatDescription": "Powtarzalny zestaw elementów",
        "recordSelector": "Selektor rekordów",
        "recordSelectorDescription": "Selektor rekordów powiązanych",
        "dateTimePicker": "Selektor daty i godziny",
        "dateTimePickerDescription": "Pole wprowadzania daty i godziny",
        "header": "Nagłówek wielostronicowy",
        "headerDescription": "Kontener współdzielony między stronami",
        "footer": "Stopka wielostronicowa",
        "footerDescription": "Kontener współdzielony między stronami",
        "notAllowedUnlessTop": "Ten element może być umieszczony tylko na górze strony",
        "notAllowedUnlessBottom": "Ten element może być umieszczony tylko na dole strony",
        "notAllowedUnlessHeader": "Ten element może być umieszczony tylko wewnątrz nagłówka strony",
        "notAllowedUnlessFooter": "Ten element może być umieszczony tylko wewnątrz stopki strony",
        "notAllowedInsideContainer": "Ten element nie może być umieszczony być wewnątrz kontenera",
        "notAllowedInsideSameType": "Ten element nie może być umieszczony w kontenerze tego samego typu",
        "ratingInput": "Pole oceny",
        "ratingInputDescription": "Element zawierający pole do wprowadzenia oceny",
        "rating": "Ocena",
        "ratingDescription": "Element zawierający ocenę",
        "invalidElementValue": "Nieprawidłowa wartość elementu: {value}",
        "notAllowedLocation": "W tym miejscu, ten element nie jest dozwolony",
        "menu": "Menu",
        "menuDescription": "Element zawierający menu",
        "simpleContainer": "Kontener",
        "simpleContainerDescription": "Kontener zawierający inne elementy",
        "fileInput": "Pole pliku",
        "fileInputDescription": "Pole służące do przesyłania plików",
        "errorValueMissing": "Brak atrybutu wartości",
        "errorEmptyContainer": "Ten kontener jest pusty",
        "errorParentWithDataSourceMissing": "Nie wybrano źródła danych dla elementu ani kontenera nadrzędnego",
        "errorDataSourceMissing": "Nie wybrano źródła danych",
        "errorSchemaPropertyMissing": "Nie wybrano atrybutu schematu",
        "errorWorkflowActionInError": "Co najmniej jedna operacja jest nieprawidłowo skonfigurowana",
        "errorCollectionFieldInError": "Co najmniej jedno pole jest nieprawidłowo skonfigurowane",
        "errorNavigateToPageMissing": "Brak atrybutu “Przejdź do\"",
        "errorPageParameterInError": "Co najmniej jeden parametr strony jest nieprawidłowo skonfigurowany",
        "errorNavigationUrlMissing": "Brak atrybutu adresu URL",
        "errorImageFileMissing": "Brak pliku obrazu",
        "errorImageUrlMissing": "Brak atrybutu adresu URL pliku graficznego",
        "errorNoWorkflowAction": "Nie skonfigurowano operacji procesu",
        "errorOptionsMissing": "Nie skonfigurowano opcji",
        "errorIframeUrlMissing": "Brak atrybutu adresu URL iFrame",
        "errorIframeContentMissing": "Brak zawartości iFrame",
        "errorNoMenuItem": "Nie skonfigurowano elementu menu",
        "errorMenuItemInError": "Co najmniej jedno menu jest nieprawidłowo skonfigurowane",
        "errorSubMenuItemInError": "Co najmniej jedno podmenu jest nieprawidłowo skonfigurowane"
    },
    "addElementButton": {
        "label": "Element"
    },
    "elementForms": {
        "textInputPlaceholder": "Wprowadź tekst...",
        "urlInputPlaceholder": "Wprowadź URL...",
        "invalidFormula": "Ta formuła jest nieprawidłowa"
    },
    "headingElement": {
        "noValue": "Bez tytułu...",
        "missingValue": "Brak tytułu...",
        "emptyValue": "Pusty tytuł..."
    },
    "pageSidePanelType": {
        "general": "Ogólne",
        "visibility": "Widoczność",
        "events": "Zdarzenia",
        "style": "Styl",
        "eventsTabDeactivatedNoEvents": "Ten element nie obsługuje żadnych zdarzeń",
        "eventsTabInError": "Co najmniej jedna z operacji jest nieprawidłowo skonfigurowana."
    },
    "emptySidePanelState": {
        "message": "Kliknij element, aby zobaczyć więcej szczegółów"
    },
    "imageElement": {
        "emptyState": "Nie zdefiniowano tekstu alternatywnego...",
        "missingValue": "Brak tekstu alternatywnego...",
        "emptyValue": "Pusty tekst alternatywny..."
    },
    "imageElementForm": {
        "fileLabel": "Plik obrazu",
        "invalidUrlError": "Adres URL jest nieprawidłowy",
        "altTextTitle": "Tekst alternatywny",
        "altTextDescription": "Jest używany przez czytniki ekranu oraz wyświetlany, jeśli nie można załadować pliku graficznego",
        "fileSourceTypeUpload": "Prześlij",
        "fileSourceTypeURL": "URL",
        "urlWarning": "Uwaga: upewnij się, czy masz kontrolę nad podanym adresem URL lub czy jest on wiarygodny.",
        "uploadFileButton": "Prześlij plik",
        "imageConstraintContain": "Zawierać",
        "maxWidthLabel": "Maksymalna szerokość",
        "maxHeightLabel": "Wysokość maks.",
        "maxHeightPlaceholder": "Wprowadź maksymalną wysokość w pikselach.",
        "maxWidthPlaceholder": "Wprowadź maksymalną szerokość jako wartość procentową.",
        "imageConstraintsLabel": "Ograniczenia",
        "imageConstraintFullWidth": "Rozszerzenie do maksymalnej szerokości",
        "imageConstraintCover": "Okładka",
        "imageConstraintCoverDisabled": "Niedostępne z pustą maksymalną wysokością.",
        "imageConstraintContainDisabled": "Niedostępne z maksymalną wysokością."
    },
    "domainTypes": {
        "customName": "Domena użytkownika",
        "subDomainName": "Subdomena",
        "subDomain": "Subdomena domeny {domain}"
    },
    "linkElement": {
        "noValue": "Bezimienny...",
        "missingValue": "Brak tekstu do linku...",
        "emptyValue": "Pusty tekst do linku..."
    },
    "linkElementForm": {
        "text": "Tekst",
        "textPlaceholder": "Wprowadź tekst...",
        "navigateTo": "Przejdź do",
        "navigateToNotSet": "Brak miejsca docelowego",
        "navigateToCustom": "Niestandardowy adres URL",
        "paramsInErrorDescription": "Zapisane parametry nie są zgodne z parametrami strony. Strona została prawdopodobnie usunięta lub zaktualizowana.",
        "paramsInErrorButton": "Zaktualizuj parametry",
        "pageParameterTypeError": "Nieprawidłowy typ",
        "url": "Docelowy adres URL",
        "variant": "Wariant",
        "variantLink": "Link",
        "urlPlaceholder": "Wprowadź adres URL...",
        "variantButton": "Przycisk",
        "width": "Szerokość",
        "widthAuto": "Auto",
        "widthFull": "Pełna szerokość",
        "target": "Otwórz w...",
        "targetSelf": "Ta sama zakładka",
        "targetNewTab": "Nowa zakładka",
        "paramPlaceholder": "Wprowadź wartość...",
        "buttonColor": "Kolor przycisku"
    },
    "alignmentSelector": {
        "alignment": "Wyrównanie",
        "alignmentLeft": "Link",
        "alignmentCenter": "Centrum",
        "alignmentRight": "Prawo"
    },
    "pageSettingsTypes": {
        "pageName": "Strona"
    },
    "pageSettings": {
        "title": "Strona",
        "pageUpdatedTitle": "Strona zaktualizowana",
        "pageUpdatedDescription": "Ustawienia strony zostały zaktualizowane."
    },
    "pathParamTypes": {
        "textName": "Tekst",
        "numericName": "Liczbowy"
    },
    "publicPage": {
        "siteNotFound": "Nie znaleziono witryny",
        "pageNotFound": "Nie znaleziono strony",
        "loginToastTitle": "Pomyślne uwierzytelnienie",
        "loginToastMessage": "Logowanie zakończyło się pomyślnie.",
        "authorizedToastTitle": "Wymagane uwierzytelnienie",
        "authorizedToastMessage": "Aby uzyskać dostęp do tej strony, musisz się zalogować. Zaloguj się, aby kontynuować."
    },
    "integrationSettings": {
        "title": "Integracje",
        "integrationMessage": "Nowe integracje można utworzyć poprzez dodanie źródła danych, operacji lub uwierzytelnienia użytkownika.",
        "noIntegrationMessage": "Nie utworzono jeszcze żadnych integracji. Aby skonfigurować integrację, dodaj źródło danych, operację lub uwierzytelnienie użytkownika."
    },
    "textElement": {
        "noValue": "Pusty akapit...",
        "missingValue": "Brak tekstu...",
        "emptyValue": "Pusty tekst..."
    },
    "textElementForm": {
        "textTitle": "Tekst",
        "textPlaceholder": "Wprowadź tekst...",
        "textError": "Ta wartość jest nieprawidłowa.",
        "textFormatTypeLabel": "Format",
        "textFormatTypePlain": "Zwykły tekst",
        "textFormatTypeMarkdown": "Markdown"
    },
    "domainSettings": {
        "titleOverview": "Domeny",
        "titleAddDomain": "Dodaj domenę",
        "addDomain": "Dodaj domenę",
        "noDomainMessage": "Z tą aplikacją nie są jeszcze powiązane żadne domeny. Aby opublikować tę aplikację, musisz dodać domenę. Możesz opublikować różne wersje aplikacji na każdej z wymienionych tutaj domen."
    },
    "dnsStatus": {
        "typeHeader": "Typ",
        "description": "Udaj się do panelu konfiguracji swoich domen i wprowadź następujące zmiany w ustawieniach DNS",
        "hostHeader": "Host",
        "valueHeader": "Wartość"
    },
    "customDomainForm": {
        "domainNameLabel": "Nazwa domeny",
        "invalidDomain": "Podana nazwa domeny jest nieprawidłowa",
        "notUniqueDomain": "Podana domena jest już używana"
    },
    "domainCard": {
        "refresh": "Odśwież ustawienia",
        "detailLabel": "Pokaż szczegóły",
        "unpublishedDomainWarning": "Opublikuj aplikację, aby udostępnić ją na tej domenie."
    },
    "dataSourceForm": {
        "namePlaceholder": "Nazwa źródła",
        "addIntegration": "Dodaj nową integrację",
        "noIntegrations": "Nie masz jeszcze żadnej integracji",
        "selectTypeFirst": "Najpierw wybierz usługę",
        "servicePlaceholder": "Wybierz usługę",
        "integrationPlaceholder": "Wybierz integrację",
        "errorUniqueName": "Nazwa źródła danych musi być unikalna.",
        "nameLabel": "Nazwa",
        "actionLabel": "Operacja",
        "integrationLabel": "Integracja"
    },
    "dataSourceContext": {
        "addDataSource": "Dodaj nowe źródło danych",
        "noDataSourceMessage": "Źródła danych służą do pobierania danych z zasobów wewnętrznych lub zewnętrznych i wyświetlania ich na stronie.",
        "noDataSourceTitle": "Nie dodałeś jeszcze żadnego źródła danych.",
        "sharedDataSourceTitle": "Współdzielone między stronami",
        "pageDataSourceTitle": "Dla tej strony",
        "sharedDataSourceDescription": "Dostępne na każdej stronie i pobierane jeden raz, przy pierwszym załadowaniu strony.",
        "pageDataSourceDescription": "Pobierane, gdy użytkownik otwiera tę stronę."
    },
    "verticalAlignmentSelector": {
        "alignmentTop": "Góra",
        "alignmentBottom": "Dół",
        "alignmentCenter": "Wyśrodkowany w pionie",
        "alignment": "Wyrównanie pionowe"
    },
    "horizontalAlignmentSelector": {
        "alignmentLeft": "Lewa",
        "alignmentRight": "Prawo",
        "alignment": "Wyrównanie poziome",
        "alignmentCenter": "Wyśrodkowany w poziomie"
    },
    "inputTextElementForm": {
        "placeholderPlaceholder": "Wprowadź symbol zastępczy (opcjonalnie)",
        "valueTitle": "Wartość domyślna",
        "valuePlaceholder": "Wprowadź wartość domyślną (opcjonalnie)",
        "placeholderTitle": "Symbol zastępczy",
        "requiredTitle": "Wymagane",
        "rowsPlaceholder": "Wprowadź liczbę wierszy tego pola",
        "inputType": "Rodzaj wprowadzanych danych",
        "inputTypeTextLabel": "Tekst",
        "inputTypePasswordLabel": "Hasło",
        "passwordTypeWarning": "Hasła to dane poufne. Prosimy o zachowanie ostrożności przy podawaniu i zapisywaniu haseł w aplikacji.",
        "multilineTitle": "Wielo-wierszowy",
        "validationTypeIntegerDescription": "Wymagaj, aby w tym polu była wpisana liczba (akceptowane są liczby całkowite lub ułamki dziesiętne).",
        "rowsTitle": "Liczba wierszy",
        "validationTypeAnyDescription": "Zezwól na wstawienie dowolnej wartości w tym polu.",
        "validationTypeAnyLabel": "Dowolny",
        "validationTypeEmailDescription": "Wymuś adresy e-mail w tym polu.",
        "validationTypeIntegerLabel": "Liczba",
        "validationTypeEmailLabel": "E-mail"
    },
    "defaultStyleForm": {
        "boxTop": "Góra",
        "boxBottom": "Dół",
        "boxLeft": "Lewo",
        "backgroundLabel": "Tło",
        "backgroundColor": "Kolor tła",
        "widthLabel": "Szerokość",
        "boxRight": "Prawo",
        "backgroundImage": "Plik graficzny",
        "backgroundImageMode": "Tryb wypełnienia",
        "cssClasses": "Klasy CSS",
        "cssClassesHelp": "Podaj klasy, które będą użyte w wygenerowanym kodzie HTML. Poszczególne klasy oddziel spacjami.",
        "cssClassesPlaceholder": "Wprowadź klasy CSS..."
    },
    "columnElementForm": {
        "columnGapPlaceholder": "Wprowadź odstęp między kolumnami...",
        "columnGapTitle": "Odstęp między kolumnami",
        "columnAmountTitle": "Układ strony",
        "columnAmountName": "brak kolumn | 1 kolumna | {columnAmount} kolumny/kolumn",
        "verticalAlignment": "Wyrównanie w pionie",
        "customLayout": "Niestandardowe",
        "customWeightsTitle": "Niestandardowy rozmiar kolumn",
        "customWeightsHelper": "Wprowadź 0, jeśli szerokość kolumny ma odpowiadać szerokości zawartości. Pozostałe kolumny podzielą między sobą pozostałą przestrzeń.",
        "errorCustomWeightsMinimum": "Rozmiar kolumny musi mieć wartość 0 lub większą",
        "columnStackingTitle": "Ustaw kolumny w zależności od rodzaju urządzenia",
        "columnStackingHorizontal": "Obok siebie",
        "columnStackingStacked": "Jedna nad drugą"
    },
    "styleBoxForm": {
        "paddingError": "Wartość musi być liczbą całkowitą z zakresu od 0 do 200.",
        "borderLabel": "Rozmiar",
        "paddingLabel": "Padding",
        "borderColor": "Kolor obramowania",
        "marginLabel": "Margines"
    },
    "dataProviderType": {
        "dataSource": "Rekordy danych",
        "pageParameter": "Parametr",
        "currentRecord": "Źródło danych",
        "previousAction": "Poprzednia operacja",
        "user": "Użytkownik",
        "formData": "Dane formularza",
        "dataSourceContext": "Dostępne opcje"
    },
    "generalForm": {
        "labelTitle": "Etykieta",
        "valueTitle": "Wartość",
        "labelPlaceholder": "Wprowadź etykietę",
        "valuePlaceholder": "Wprowadź wartość",
        "placeholderTitle": "Tekst-wskazówka (placeholder)",
        "placeholderPlaceholder": "Wprowadź tekst-wskazówkę (placeholder)",
        "requiredTitle": "Wymagane",
        "validationTitle": "Walidacja",
        "defaultValueTitle": "Wartość domyślna",
        "defaultValuePlaceholder": "Wprowadź wartość domyślną"
    },
    "iframeElementForm": {
        "sourceTypeLabel": "Typ źródła",
        "empty": "Pusty IFrame...",
        "urlLabel": "Adres URL",
        "urlPlaceholder": "Link do zewnętrznego zasobu, który ma zostać osadzony",
        "urlHelp": "Uwaga: upewnij się, czy masz kontrolę nad podanym adresem URL lub czy jest on wiarygodny.",
        "embedLabel": "Osadź",
        "embedPlaceholder": "Kod HTML do osadzenia",
        "heightLabel": "Wysokość (px)",
        "heightPlaceholder": "Wysokość w pikselach",
        "missingValue": "Brak źródła iFrame...",
        "emptyValue": "Puste źródło iFrame..."
    },
    "backgroundTypes": {
        "none": "Brak",
        "color": "Kolor"
    },
    "eventTypes": {
        "clickLabel": "Po kliknięciu",
        "submitLabel": "Po wysłaniu",
        "afterLoginLabel": "Po zalogowaniu"
    },
    "getFormulaComponent": {
        "errorTooltip": "Nieprawidłowe odniesienie"
    },
    "tableElementForm": {
        "fieldValueLabel": "Wartość",
        "itemsPerPage": "Pozycji na stronę",
        "fieldDefaultName": "Kolumna",
        "fieldType": "Typ",
        "itemsPerPagePlaceholder": "Wprowadź wartość...",
        "selectSourceFirst": "Aby rozpocząć konfigurację pól, wybierz źródło danych listy i/lub atrybut.",
        "buttonColor": "Kolor przycisku",
        "addField": "dodaj pole",
        "fieldValuePlaceholder": "Wprowadź wartość...",
        "dataSource": "Źródło danych",
        "fields": "Pola",
        "name": "Nazwa",
        "noName": "Brak nazwy",
        "refreshFieldsFromDataSource": "odśwież pola ze źródła danych",
        "buttonLoadMoreLabel": "Etykieta “Pokaż więcej\"",
        "propertySelectorMissingArrays": "Nie znaleziono pól wielowartościowych do użycia jako wiersze."
    },
    "tableElement": {
        "empty": "Nie znaleziono żadnych elementów.",
        "showMore": "Pokaż więcej"
    },
    "currentRecordDataProviderType": {
        "index": "Indeks",
        "firstPartName": "Źródło danych: {name}",
        "schemaProperty": "{prefixName}: {schemaProperty}"
    },
    "linkFieldForm": {
        "fieldLinkNameLabel": "Tekst linku",
        "fieldValueLabel": "Adres URL",
        "fieldValuePlaceholder": "Wprowadź wartość...",
        "fieldLinkNamePlaceholder": "Wprowadź wartość...",
        "buttonColor": "Kolor przycisku"
    },
    "textFieldForm": {
        "fieldValueLabel": "Wartość",
        "fieldValuePlaceholder": "Wprowadź wartość..."
    },
    "linkField": {
        "details": "Szczegóły"
    },
    "createUserSourceForm": {
        "userSourceType": "Typ",
        "userSourceIntegration": "Integracja",
        "userSourceName": "Nazwa"
    },
    "updateUserSourceForm": {
        "nameFieldPlaceholder": "Wprowadź nazwę...",
        "authTitle": "Uwierzytelnianie",
        "integrationFieldLabel": "Integracja",
        "nameFieldLabel": "Nazwa",
        "addProvider": "Dodaj dostawcę"
    },
    "dropdownOptionSelector": {
        "name": "Nazwa",
        "addOption": "dodać opcję",
        "label": "Opcje",
        "value": "Wartość"
    },
    "dispatchDataSourceError": {
        "defaultMessage": "Wystąpił błąd podczas ładowania danych dla strony.",
        "defaultTitle": "Błąd ładowania danych"
    },
    "upsertRowWorkflowActionForm": {
        "integrationDropdownLabel": "Integracja",
        "rowIdLabel": "Identyfikator wiersza",
        "rowIdPlaceholder": "Wybierz identyfikator wiersza",
        "fieldMappingPlaceholder": "Wybierz wartość pola",
        "noTableSelectedMessage": "Wybierz tabelę, aby rozpocząć konfigurację pól."
    },
    "checkboxElementForm": {
        "requiredTitle": "Wymagane",
        "labelTitle": "Nazwa opcji",
        "valueTitle": "Wartość domyślna"
    },
    "userSourceUsersContext": {
        "searchPlaceholder": "Szukaj użytkownika",
        "anonymous": "Niezalogowany",
        "unnamed": "Bez nazwy",
        "noEmail": "Brak e-maila"
    },
    "visibilityForm": {
        "allVisitors": "Wszyscy odwiedzający",
        "loggedInVisitors": "Zalogowani odwiedzający",
        "notLoggedInVisitors": "Niezalogowani odwiedzający",
        "warningTitle": "To jest funkcja zabezpieczająca",
        "warningMessage": "Kliknij {link}, aby dowiedzieć się więcej o tym, jak zabezpieczamy dane.",
        "documentationLink": "dokumentacja",
        "excludedRolesLabel": "wszystkie role z wyjątkiem",
        "switchAllowLabel": "Zezwalaj",
        "switchDisallowLabel": "Wyklucz",
        "rolesSelectAll": "Zaznacz wszystko",
        "rolesDeselectAll": "Odznacz wszystko",
        "rolesSelectHint": "Wybierz jedną lub więcej ról",
        "roleTypesHint": "Wybierz rodzaj roli",
        "roleTypeAllowAllRoles": "Wszystkie role",
        "roleTypeAllowAllRolesExcept": "Wykluczone role…",
        "roleTypeDisallowAllRolesExcept": "Dozwolone role…",
        "rolesAllMembersOf": "Wszyscy członkowie {name}",
        "noRole": "Brak roli",
        "errorFetchingRolesTitle": "Nie udało się pobrać ról użytkowników",
        "errorFetchingRolesMessage": "Wystąpił problem podczas pobierania ról użytkowników.",
        "visibilityCondition": "Wyświetlanie warunkowe",
        "visibilityConditionHelper": "Jeśli wynik tej formuły jest prawdziwy i powyższy wybór odwiedzającego też jest prawdziwy, to element będzie widoczny. Funkcja ta ma wyłącznie wpływ na widoczność elementu, a nie na zawartość odpowiedzi serwera. Aby wstrzymać wysyłanie danych w odpowiedzi serwera, użyj opcji filtrowania według roli użytkownika.",
        "visibilityConditionPlaceholder": "Warunek..."
    },
    "formDataProviderType": {
        "nodeMissing": "Brakujący"
    },
    "userSourceSettings": {
        "titleAddUserSource": "Nowe źródło użytkownika",
        "titleUpdateUserSource": "Edytuj źródło użytkownika",
        "titleOverview": "Źródła użytkowników",
        "addUserSource": "Dodaj źródło użytkowników",
        "noUserSourceMessage": "Nie dodałeś jeszcze źródła użytkowników do tej aplikacji. Jeśli chcesz umożliwić użytkownikom logowanie się do tej aplikacji, potrzebne jest źródło użytkowników."
    },
    "domainForm": {
        "invalidDomain": "Nazwa domeny jest niepoprawna",
        "notUniqueDomain": "Podana domena jest już w użyciu"
    },
    "subDomainForm": {
        "domainNameLabel": "Nazwa domeny"
    },
    "widthSelector": {
        "width": "Szerokość",
        "widthAuto": "Automatyczna",
        "widthFull": "Pełna szerokość"
    },
    "widthTypes": {
        "full": "Pełna szerokość",
        "normal": "Normalny",
        "medium": "Średni",
        "small": "Mały",
        "fullBleed": "Całkowite wypełnienie",
        "fullWidth": "Pełna szerokość"
    },
    "buttonElementForm": {
        "valueLabel": "Tekst na przycisku",
        "valuePlaceholder": "Wprowadź tekst...",
        "buttonColor": "Kolor przycisku"
    },
    "fontSidePanelForm": {
        "label": "Kolor czcionki"
    },
    "workflowActionTypes": {
        "notificationLabel": "Pokaż powiadomienie",
        "openPageLabel": "Otwórz stronę",
        "createRowLabel": "Utwórz wiersz",
        "updateRowLabel": "Aktualizuj wiersz",
        "logoutLabel": "Wyloguj się",
        "refreshDataSourceLabel": "Odśwież źródło danych",
        "httpRequest": "Wyślij żądanie HTTP",
        "errorNavigateToPageMissing": "Brak atrybutu “Przejdź do strony\"",
        "errorPageParameterInError": "Przynajmniej jeden z parametrów strony jest nieprawidłowo skonfigurowany",
        "errorNavigationUrlMissing": "Brak atrybutu adresu URL",
        "errorDataSourceMissing": "Nie wybrano źródła danych"
    },
    "notificationWorkflowActionForm": {
        "titleLabel": "Tytuł",
        "titlePlaceholder": "Wprowadź tekst...",
        "descriptionPlaceholder": "Wprowadź tekst...",
        "descriptionLabel": "Opis"
    },
    "openPageWorkflowActionForm": {
        "urlPlaceholder": "Wprowadź tekst...",
        "urlLabel": "Adres URL"
    },
    "event": {
        "addAction": "dodaj operację"
    },
    "formContainerElementForm": {
        "submitButtonPlaceholder": "Wprowadź wartość...",
        "submitButtonLabel": "Przycisk wysyłania",
        "buttonColor": "Kolor przycisku",
        "resetToInitialValuesTitle": "Przywróć wartości domyślne po wysłaniu",
        "resetToInitialValuesDescription": "Jeśli opcja jest zaznaczona, to po pomyślnym wysłaniu, formularz zostanie zresetowany i wypełniony wartościami domyślnymi. Jeśli opcja nie jest zaznaczona, wprowadzone wartości nie zostaną zresetowane."
    },
    "subDomainDetails": {
        "text": "Ustawienia DNS domeny zostały skonfigurowane i sprawdzone. Nie ma konieczności wprowadzania dodatkowych modyfikacji."
    },
    "linkNavigationSelection": {
        "paramPlaceholder": "Wprowadź wartość...",
        "urlPlaceholder": "Wprowadź adres URL...",
        "url": "Docelowy adres URL",
        "paramsInErrorDescription": "Zapisane parametry nie są zgodne z parametrami strony. Strona została prawdopodobnie usunięta lub zmieniona.",
        "paramsInErrorButton": "Zaktualizuj parametry",
        "navigateTo": "Przejdź do",
        "navigateToCustom": "Własny adres URL",
        "target": "Otwórz w...",
        "targetSelf": "Tej samej karcie",
        "targetNewTab": "Nowej karcie"
    },
    "mainThemeConfigBlock": {
        "colorsLabel": "Kolory",
        "primaryColor": "Podstawowe",
        "secondaryColor": "Drugorzędny",
        "typography": "Typografia",
        "headingLabel": "Nagłówek {i} (h{i})",
        "headingValue": "Nagłówek <h{i}>"
    },
    "buttonElement": {
        "noValue": "Bezimienny...",
        "missingValue": "Brak tekstu na przycisku...",
        "emptyValue": "Tekst na przycisku jest pusty..."
    },
    "collectionFieldType": {
        "text": "Tekst",
        "link": "Link",
        "boolean": "Wartość logiczna",
        "button": "Przycisk",
        "tags": "Tagi",
        "image": "Plik graficzny",
        "rating": "Ocena",
        "errorValueMissing": "Brak atrybutu wartości"
    },
    "formContainerElement": {
        "submitDeactivatedText": "Wypełnij wszystkie wymagane pola, aby wysłać formularz",
        "defaultSubmitButtonLabel": "Wyślij"
    },
    "dispatchWorkflowActionError": {
        "defaultTitle": "Błąd zdarzenia",
        "defaultMessage": "Wystąpił błąd wyzwalający to zdarzenie.",
        "formDataInvalidMessage": "Jedno lub więcej pól zawiera nieprawidłowe wartości.",
        "formDataInvalidTitle": "Nieprawidłowy formularz"
    },
    "authFormElementForm": {
        "userSource": "Źródło użytkownika"
    },
    "authFormElement": {
        "email": "E-mail",
        "password": "Hasło",
        "emailPlaceholder": "Wpisz swój adres e-mail...",
        "passwordPlaceholder": "Wprowadź swoje hasło.",
        "selectOrConfigureUserSourceFirst": "Wybierz źródło użytkownika, aby rozpocząć korzystanie z tego elementu logowania."
    },
    "pagePreview": {
        "emptyMessage": "Kliknij, aby utworzyć element",
        "header": "NAGŁÓWEK",
        "footer": "STOPKA"
    },
    "userSelector": {
        "viewAs": "Zobacz jako: {user}",
        "anonymous": "Niezalogowany",
        "member": "{prefix} członek"
    },
    "generalSettings": {
        "titleOverview": "Ogólne",
        "labelForm": "Ikona favicon",
        "labelDescription": "Wybierz plik ICO, PNG, GIF lub JPEG o wymiarach 128×128 px.",
        "labelButton": "Prześlij ikonę favicon",
        "cantUploadFaviconTitle": "Nie udało się przesłać pliku z ikoną favicon",
        "cantUploadFaviconDescription": "Nie udało się przesłać pliku z ikoną favicon. Sprawdź, czy plik ma unikalną nazwę i czy jest zapisany w obsługiwanym formacie.",
        "cantUpdateApplicationTitle": "Nie udało się zaktualizować aplikacji",
        "cantUpdateApplicationDescription": "Przepraszamy, nie udało się zaktualizować aplikacji."
    },
    "choiceOptionSelector": {
        "dataSource": "Źródło danych",
        "label": "Opcje",
        "value": "Wartości opcji",
        "valuePlaceholder": "Wprowadź wartość",
        "name": "Nazwy opcji",
        "namePlaceholder": "Wprowadź nazwę",
        "addOption": "dodaj opcję",
        "addOptionDescription": "Kliknij “dodaj opcję\", aby dodać opcje do listy rozwijanej",
        "optionType": "Typ opcji",
        "manual": "Ręcznie",
        "formulas": "Formuły"
    },
    "repeatElementForm": {
        "dataSource": "Źródło danych",
        "itemsPerPage": "Pozycji na stronie",
        "itemsPerPagePlaceholder": "Wprowadź wartość...",
        "itemsPerRowLabel": "Liczba pozycji w wierszu",
        "itemsPerRowDescription": "Liczba kolumn w wierszu wg. typu urządzenia.",
        "buttonLoadMoreLabel": "Etykieta \"Pokaż więcej\"",
        "toggleEditorRepetitionsLabel": "Tymczasowo wyłącz powtórzenia",
        "propertySelectorMissingArrays": "Nie znaleziono pól wielowartościowych do powtarzania.",
        "gapLabel": "Odstęp między powtórzeniami",
        "gapVerticalLabel": "Pionowy",
        "gapHorizontalLabel": "Poziomy"
    },
    "dataSourceDropdown": {
        "label": "Źródło danych",
        "noDataSources": "Brak dostępnych źródeł danych",
        "noSharedDataSources": "Brak dostępnych współdzielonych źródeł danych",
        "shared": "współdzielone",
        "pageOnly": "ta strona",
        "addNew": "Dodaj nowe źródło danych"
    },
    "common": {
        "dateFormatTitle": "Format daty",
        "dateFormatEU": "Europejski",
        "dateFormatUS": "US",
        "dateFormatISO": "ISO",
        "timeFormatTitle": "Format godziny",
        "timeFormat24Hour": "24 godziny",
        "timeFormat12Hour": "12 godzin"
    },
    "builderToast": {
        "details": "Szczegóły",
        "defaultTitle": "Nieoczekiwany błąd",
        "defaultMessage": "Wystąpił nieoczekiwany błąd. Spróbuj ponownie później.",
        "invalidContextTitle": "Nieprawidłowe żądanie",
        "invalidContextMessage": "To żądanie nie jest sformułowane prawidłowo.",
        "InvalidContentTitle": "Nieprawidłowy formularz",
        "invalidContentMessage": "Co najmniej jedno pole zawiera nieprawidłową wartość.",
        "serviceMisconfiguredTitle": "Niekompletna konfiguracja",
        "serviceMisconfiguredMessage": "Sprawdź konfigurację.",
        "errorWorkflowActionDispatch": "Operacja “{name}\" nie powiodła się: ",
        "errorDataSourceDispatch": "Nie udało się załadować danych “{name}\": "
    },
    "addElementCategory": {
        "suggestedElement": "Sugerowane elementy",
        "baseElement": "Elementy podstawowe",
        "layoutElement": "Elementy układu strony",
        "formElement": "Elementy formularza"
    },
    "orientations": {
        "label": "Orientacja",
        "horizontal": "Pozioma",
        "vertical": "Pionowa"
    },
    "menuElement": {
        "missingValue": "Brak pozycji w menu",
        "separator": "Separator",
        "spacer": "Odstęp",
        "missingLinkValue": "Brak nazwy linku...",
        "emptyLinkValue": "Pusta nazwa linku...",
        "missingButtonValue": "Brak nazwy przycisku...",
        "emptyButtonValue": "Pusta nazwa przycisku..."
    },
    "menuElementForm": {
        "menuItemsLabel": "Elementy menu",
        "addMenuItemLink": "Dodaj...",
        "alignment": "Wyrównanie",
        "menuItemDefaultName": "Strona",
        "menuItemLabelLabel": "Etykieta",
        "menuItemTypeLabel": "Typ",
        "menuItemTypeSeparator": "Separator",
        "menuItemVariantLabel": "Wariant",
        "menuItemVariantLink": "Link",
        "menuItemVariantButton": "Przycisk",
        "namePlaceholder": "Strona",
        "addSubLink": "Dodaj link podrzędny",
        "menuItemSubLinkDefaultName": "Link podrzędny",
        "menuItemAddLink": "Link",
        "menuItemAddButton": "Przycisk",
        "menuItemAddSeparator": "Separator",
        "menuItemAddSpacer": "Odstęp",
        "eventDescription": "Aby skonfigurować operacje dla tego przycisku, otwórz zakładkę “Zdarzenia”.",
        "noMenuItemsMessage": "Aby dodać pierwszy element menu, kliknij “Dodaj\".",
        "variant": "Wariant w zależności od rodzaju urządzenia",
        "expanded": "Rozszerzony",
        "compact": "Kompaktowy",
        "previewCompactMenuLabel": "Podgląd menu kompaktowego",
        "previewCompactMenuHelper": "Pokaż/ukryj podgląd menu kompaktowego.",
        "openEditorCompactMenu": "Otwórz menu",
        "closeEditorCompactMenu": "Zamknij menu"
    },
    "simpleContainerElementForm": {
        "noConfigurationOptions": "Ten kontener nie ma żadnych opcji konfiguracji."
    },
    "dateTimePickerElementForm": {
        "includeTime": "Uwzględnij godzinę",
        "invalidDateError": "Nieprawidłowa data. Sprawdź, czy wpisana data jest zgodna z podanym formatem."
    },
    "themeSettings": {
        "titleOverview": "Motyw"
    },
    "pageVisibilitySettingsTypes": {
        "pageName": "Widoczność",
        "logInPageWarningTitle": "Strona logowania nie została jeszcze skonfigurowana",
        "logInPagewarningMessage": "Jeśli niezalogowany użytkownik spróbuje otworzyć tę stronę, to zostanie przekierowany na stronę logowania. Przypisz stronę logowania w ustawieniach ogólnych aplikacji.",
        "logInPageInfoTitle": "Użytkownicy niezalogowani zostaną przekierowani",
        "logInPageInfoMessage": "Użytkownicy niezalogowani próbujący otworzyć tę stronę zostaną przekierowani na stronę {logInPageName}."
    },
    "pageVisibilitySettings": {
        "title": "Widoczność",
        "allVisitors": "Wszyscy odwiedzający",
        "loggedInVisitors": "Zalogowani użytkownicy",
        "description": "Kto może zobaczyć tę stronę"
    },
    "queryParamTypes": {
        "textName": "Tekst",
        "numericName": "Liczbowy"
    },
    "pageEditor": {
        "title": "Konfigurator aplikacji",
        "pageNotFound": "Nie znaleziono strony"
    },
    "dataSourceItem": {
        "notConfigured": "Nieskonfigurowany"
    },
    "dataSourceItemContext": {
        "shareBetweenPages": "Udostępnij na innych stronach",
        "unshareBetweenPages": "Wycofaj udostępnienie na innych stronach"
    },
    "dataSourceCreateEditModal": {
        "editTitle": "Edytuj źródło danych",
        "createTitle": "Utwórz źródło danych",
        "sharedWarning": "To źródło danych jest współdzielone, więc Twoje zmiany mogą mieć wpływ na inne strony."
    },
    "radiusStyleForm": {
        "cornerRadiusLabel": "Zaokrąglenie narożników",
        "backgroundRadiusLabel": "Tło",
        "borderRadiusLabel": "Obramowanie"
    },
    "themeConfigBlockType": {
        "color": "Kolory",
        "page": "Strona",
        "typography": "Typografia",
        "button": "Przycisk",
        "link": "Link",
        "image": "Plik graficzny",
        "input": "Pole wprowadzania danych",
        "table": "Tabela"
    },
    "colorThemeConfigBlock": {
        "transparent": "Przezroczysty",
        "primaryColor": "Główny",
        "secondaryColor": "Podrzędny",
        "borderColor": "Obramowanie",
        "successColor": "Sukces",
        "warningColor": "Ostrzeżenie",
        "errorColor": "Błąd",
        "customColors": "Kolory niestandardowe",
        "addCustomColor": "Dodaj kolor niestandardowy",
        "customColorPrefix": "Niestandardowy"
    },
    "pageThemeConfigBlock": {
        "backgroundColor": "Kolor tła",
        "backgroundImage": "Plik graficzny w tle",
        "backgroundMode": "Tryb tła"
    },
    "colorThemeConfigBlockType": {
        "transparent": "Przezroczysty",
        "primary": "Główny",
        "secondary": "Podrzędny",
        "border": "Obramowanie",
        "success": "Sukces",
        "warning": "Ostrzeżenie",
        "error": "Błąd"
    },
    "typographyThemeConfigBlock": {
        "headingLabel": "Nagłówek {i} (h{i})",
        "headingValue": "Nagłówek <h{i}>",
        "color": "Kolor",
        "size": "Rozmiar",
        "weight": "Grubość",
        "textAlignment": "Wyrównanie",
        "bodyLabel": "Tekst podstawowy",
        "decoration": "Dekoracja tekstu",
        "fontFamily": "Czcionka"
    },
    "fontWeightType": {
        "thin": "Cienka",
        "extraLight": "Bardzo lekka",
        "light": "Lekka",
        "regular": "Normalna",
        "medium": "Średnia",
        "semiBold": "Pół-pogrubiona",
        "bold": "Pogrubiona",
        "extraBold": "Bardzo pogrubiona",
        "black": "Ekstra pogrubiona",
        "extraBlack": "Najgrubsza"
    },
    "buttonThemeConfigBlock": {
        "backgroundColor": "Kolor tła",
        "button": "Przycisk",
        "defaultState": "Stan domyślny",
        "hoverState": "Po najechaniu myszą",
        "activeState": "Stan aktywny",
        "textAlignment": "Wyrównanie tekstu",
        "alignment": "Wyrównanie",
        "width": "Szerokość",
        "textColor": "Kolor tekstu",
        "borderColor": "Kolor obramowania",
        "borderSize": "Grubość obramowania",
        "borderRadius": "Zaokrąglenie narożników",
        "padding": "Padding",
        "fontFamily": "Czcionka",
        "size": "Rozmiar czcionki",
        "weight": "Grubość czcionki"
    },
    "linkThemeConfigBlock": {
        "color": "Kolor",
        "link": "Link",
        "defaultState": "Stan domyślny",
        "hoverState": "Po najechaniu myszą",
        "activeState": "Stan aktywny",
        "alignment": "Wyrównanie",
        "fontFamily": "Czcionka",
        "size": "Rozmiar czcionki",
        "weight": "Grubość czcionki",
        "decoration": "Dekoracja tekstu"
    },
    "inputThemeConfigBlock": {
        "label": "Etykieta",
        "input": "Pole wprowadzania danych",
        "backgroundColor": "Kolor tła",
        "textColor": "Kolor tekstu",
        "borderColor": "Kolor obramowania",
        "borderSize": "Grubość obramowania",
        "borderRadius": "Zaokrąglenie narożników",
        "padding": "Padding",
        "fontFamily": "Czcionka",
        "size": "Rozmiar czcionki",
        "weight": "Grubość czcionki"
    },
    "imageThemeConfigBlock": {
        "alignment": "Wyrównanie",
        "maxWidthLabel": "Maksymalna szerokość",
        "maxHeightLabel": "Maksymalna wysokość",
        "maxHeightPlaceholder": "Wprowadź maksymalną wysokość",
        "maxWidthPlaceholder": "Wprowadź maksymalną szerokość",
        "imageConstraintsLabel": "Ograniczenia",
        "imageConstraintFullWidth": "Rozszerz do maksymalnej szerokości",
        "imageConstraintCover": "Dopasuj (cover)",
        "imageConstraintCoverDisabled": "Opcja niedostępna, jeśli nie podano maksymalnej wysokości.",
        "imageConstraintContain": "Wypełnij (contain)",
        "imageConstraintContainDisabled": "Opcja niedostępna, jeśli podano maksymalną wysokość.",
        "imageBorderRadiusLabel": "Zaokrąglenie narożników",
        "imageBorderRadiusPlaceholder": "Wprowadź wartość zaokrąglenia obramowania narożników grafiki."
    },
    "tableThemeConfigBlock": {
        "borderColor": "Kolor obramowania",
        "backgroundAlternateColor": "Kolor parzystych wierszy",
        "backgroundColor": "Kolor tła",
        "textColor": "Kolor tekstu",
        "borderSize": "Grubość obramowania",
        "borderRadius": "Zaokrąglenie narożników",
        "padding": "Padding",
        "fontFamily": "Czcionka",
        "size": "Rozmiar",
        "fontSize": "Rozmiar czcionki",
        "fontWeight": "Grubość czcionki",
        "table": "Tabela",
        "header": "Nagłówek",
        "alignment": "Wyrównanie",
        "cells": "Komórki",
        "separators": "Separatory",
        "verticalSeparatorColor": "Kolor pionowy",
        "verticalSeparatorSize": "Rozmiar pionowy",
        "horizontalSeparatorColor": "Kolor poziomy",
        "horizontalSeparatorSize": "Rozmiar poziomy"
    },
    "choiceElementForm": {
        "multiple": "Zezwalaj na wiele wartości",
        "display": "Wyświetlanie",
        "dropdown": "Lista rozwijana",
        "checkbox": "Pole wyboru",
        "radio": "Przycisk opcji"
    },
    "dropdown": {
        "empty": "Brak opcji do wyboru"
    },
    "abTable": {
        "loading": "Wczytywanie...",
        "empty": "Nie znaleziono żadnych pozycji."
    },
    "repeatElement": {
        "empty": "Nie znaleziono żadnych pozycji.",
        "showMore": "Pokaż więcej",
        "missingDataSourceTooltip": "Wybierz źródło danych, aby rozpocząć dodawanie elementów.",
        "missingSchemaPropertyTooltip": "Wybierz atrybut, aby rozpocząć dodawanie elementów.",
        "emptyState": "Nie znaleziono rekordów."
    },
    "collectionElementForm": {
        "noDataSourceMessage": "Wybierz źródło danych z wieloma wierszami, aby wyświetlić wszystkie rezultaty. Alternatywnie, aby wybrać atrybut we wierszu, wybierz źródło danych z pojedynczym wierszem.",
        "noSchemaPropertyMessage": "Wybierz atrybut wewnątrz źródła danych, który ma służyć jako dane listy elementu.",
        "propertyOptionLabel": "Operacje użytkownika"
    },
    "propertyOptionForm": {
        "fieldHeading": "Pole",
        "filterHeading": "Filtr",
        "sortHeading": "Sortowanie",
        "searchHeading": "Wyszukiwanie",
        "optionUnavailable": "Niedostępne",
        "noPropertiesAvailable": "Brak dostępnych pól.",
        "formDescription": "Wybierz, które atrybuty w źródle danych tego elementu mogą być filtrowane, sortowane i wyszukiwane przez odwiedzających stronę."
    },
    "recordSelectorElement": {
        "emptyAdhocState": "Nie znaleziono rekordów pasujących do zapytania '{query}'.",
        "emptyState": "Nie znaleziono rekordów."
    },
    "recordSelectorElementForm": {
        "selectRecordsFrom": "Wybierz rekordy z",
        "noDataSourceMessage": "Aby wyświetlić wszystkie wyniki, wybierz źródło danych z wieloma wierszami.",
        "optionNameSuffix": "Sufiks nazwy opcji",
        "optionNameSuffixPlaceholder": "Wprowadź sufiks...",
        "optionNameSuffixHelper": "Ten sufiks jest dodawany do nazwy każdej opcji na liście rozwijanej. Pomaga to odróżnić poszczególne pozycje.",
        "itemsPerPage": "Liczba pozycji na stronie",
        "itemsPerPagePlaceholder": "Wprowadź wartość...",
        "multipleLabel": "Zezwalaj na wiele wartości",
        "record": "Rekord {id}"
    },
    "tagsFieldForm": {
        "fieldValuesLabel": "Wartości",
        "fieldValuesPlaceholder": "Wprowadź wartości...",
        "fieldColorsLabel": "Kolory",
        "fieldColorsPlaceholder": "Wprowadź kolory…"
    },
    "imageFieldForm": {
        "fieldSrcLabel": "Źródło obrazu",
        "fieldSrcPlaceholder": "Wprowadź wartość",
        "fieldAltLabel": "Tekst alternatywny",
        "fieldAltPlaceholder": "Wprowadź wartość...",
        "fieldAltHelp": "Używany przez czytniki ekranu i wyświetlany, gdy nie można załadować pliku graficznego"
    },
    "builderLoginPageForm": {
        "pageDropdownLabel": "Strona logowania",
        "pageDropdownPlaceholder": "Wybierz stronę",
        "pageDropdownDescription": "Wybierz stronę logowania, na którą zostaną przekierowani niezalogowani użytkownicy, gdy otworzą stronę z ograniczonym dostępem."
    },
    "fieldMappingContext": {
        "enableField": "Aktywuj pole",
        "disableField": "Dezaktywuj pole"
    },
    "choiceElement": {
        "addOptions": "Aby użyć tego elementu, dodaj opcje..."
    },
    "userDataProviderType": {
        "isAuthenticated": "Jest uwierzytelniony",
        "id": "ID",
        "email": "E-mail",
        "username": "Nazwa użytkownika",
        "role": "Rola"
    },
    "buttonField": {
        "noLabel": "Bez nazwy..."
    },
    "buttonFieldForm": {
        "infoMessage": "Otwórz zakładkę “Zdarzenia\", aby skonfigurować funkcje tego przycisku.",
        "labelPlaceholder": "Wprowadź etykietę..."
    },
    "resetButton": {
        "reset": "Przywróć domyślne ustawienia motywu"
    },
    "backgroundModes": {
        "fill": "Wypełnienie",
        "tile": "Kafelek",
        "fit": "Dopasuj"
    },
    "customStyle": {
        "backToElement": "Powrót do konfiguracji elementu",
        "configureThemeOverrides": "Skonfiguruj zmiany motywu dotyczące tego elementu"
    },
    "serviceSchemaPropertySelector": {
        "label": "Atrybut",
        "noProperties": "Brak dostępnych atrybutów"
    },
    "userSourceDropdown": {
        "label": "Źródło użytkowników",
        "addUserSource": "Dodaj nowe źródło użytkowników",
        "noUserSources": "Brak dostępnych źródeł użytkowników"
    },
    "multiPageContainerElementForm": {
        "pagePosition": "Pozycja",
        "behaviour": "Zachowanie",
        "display": "Wyświetlanie",
        "selectAll": "Zaznacz wszystko",
        "deselectAll": "Odznacz wszystko"
    },
    "pageShareType": {
        "all": "Na wszystkich stronach",
        "only": "Tylko na wybranych stronach",
        "except": "Wyklucz wybrane strony"
    },
    "authProviderWithModal": {
        "authProviderInError": "Aby naprawić błąd, popraw dane dostawcy.",
        "title": "Edycja danych dostawcy: {name}"
    },
    "textDecorationSelector": {
        "underline": "Podkreślenie",
        "stroke": "Przekreślenie",
        "italic": "Kursywa",
        "uppercase": "Wielkie litery"
    },
    "ratingFieldForm": {
        "maxValue": "Wartość maksymalna",
        "color": "Kolor",
        "style": "Styl",
        "star": "Gwiazdka",
        "heart": "Serduszko",
        "thumbsUp": "Kciuk",
        "flag": "Flaga",
        "value": "Wartość"
    },
    "ratingElementForm": {
        "maxValue": "Maksimum",
        "color": "Kolor",
        "ratingStyle": "Styl",
        "star": "Gwiazdka",
        "heart": "Serduszko",
        "smile": "Uśmiech",
        "thumbsUp": "Kciuk",
        "flag": "Flaga"
    },
    "automationSettingsModal": {
        "title": "Proces"
    },
    "abFileInput": {
        "delete": "Usuń"
    },
    "elementsGuidedTourStep": {
        "title": "Dodaj elementy do strony",
        "content": "W każdej aplikacji potrzebne są elementy składowe! Aby wypełnić swoją aplikację, dodaj tabele, formularze, przyciski itp."
    },
    "dataGuidedTourStep": {
        "title": "Połącz swoje dane",
        "content": "Tutaj możesz połączyć tabele w bazie Baserow i wyświetlać, filtrować oraz dynamicznie aktualizować dane w różnych elementach."
    },
    "previewGuidedTourStep": {
        "title": "Twoje centrum zarządzania",
        "content": "Tutaj skonfigurujesz strony swojej aplikacji. Wstaw elementy, zobacz, jak działają i dostosuj strukturę aplikacji do swoich potrzeb."
    },
    "devicesGuidedTourStep": {
        "title": "Podgląd na różnych urządzeniach",
        "content": "Aby zobaczyć, jak aplikacja wygląda na różnych rozmiarach ekranów, przełącz się między podglądami na ekranie komputera, tabletu lub smartfonu. Sprawdź, czy Twój układ wygląda poprawnie na każdym urządzeniu!"
    },
    "sidePanelGuidedTourStep": {
        "title": "Panel boczny: dostosuj elementy",
        "content": "**Zakładka Ogólne** – skonfiguruj wybrany element.\n\n**Zakładka Styl** – dopasuj padding, marginesy, obramowania itd.\n\n**Zakładka Widoczność** – zdecyduj, kto może zobaczyć element: zalogowani użytkownicy, niezalogowani użytkownicy lub użytkownicy o określonych rolach.\n\n**Zakładka Zdarzenia** – jeśli dany element obsługuje operacje, skonfiguruj je tutaj; umożliwi to dynamiczne wyświetlanie danych."
    },
    "previewPublishGuidedTourStep": {
        "title": "Podgląd i publikacja aplikacji",
        "content": "Kliknij **Podgląd**, aby przetestować aplikację w trybie prywatnym. Gdy wszystko będzie gotowe, kliknij **Opublikuj**, aby udostępnić aplikację publicznie za pośrednictwem domeny."
    },
    "workflowAction": {
        "sampleDataModalTitle": "Payload operacji {actionLabel}",
        "sampleDataModalSubTitle": "Payload JSON",
        "testActionDescription": "Uruchom tę operację w trybie podglądu; umożliwi to zarejestrowanie jej wyniku i wykorzystanie go w kolejnych operacjach."
    }
}
